import * as _ from 'lodash';
import { ReorderArticle } from './searcher.types';
import { getMatrixSelectedAmount } from 'app/b2b-order/helpers/order';

export const adaptReorderArticleToOrderMatrix = (article: Omit<ReorderArticle, 'forOrderMatrix'>) => ({
    color: article.color,
    sizes: _.map(article.sizes, (size) => ({
        name: size.size,
        gtin: size.gtin,
        stock: size.stock.available,
        amount: getMatrixSelectedAmount(size.stock.selectedAmount),
        price: size.price
    })),
    brandId: article.brandId,
    styleGroupId: article.styleGroupId,
    imageUrl: article.imageUrl,
    discountedPurchasePrice: article.price.discountedPurchasePrice,
    purchasePrice: article.price.purchasePrice,
    recommendedRetailPrice: article.price.recommendedRetailPrice,
    currency: article.price.currency,
    prepacks: []
});
